export default "__VITE_PUBLIC_ASSET__eb0ab0c6__"